import { render } from "./index.vue?vue&type=template&id=437c31d0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=437c31d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437c31d0"],['__file',"src/views/Home/RetailProducts/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "437c31d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('437c31d0', __exports__)) {
    console.log('reload')
    api.reload('437c31d0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=437c31d0&scoped=true", () => {
    console.log('re-render')
    api.rerender('437c31d0', render)
  })

}


export default __exports__